import styles from './stylesChartNav.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const ChartsTypeNavCurrent = ({ value, t }) => {
  return (
    <div className={styles.chartNavCurrent}>
      <div className={styles.chartNavCurrentIcon}>
        {value === 'weather' && <CroplerIcon name="weather" />}
        {value === 'crop' && <CroplerIcon name="soliSensor" />}
        {value === 'soil' && <CroplerIcon name="soil" />}
        {value === 'custom' && <CroplerIcon name="custom" />}
      </div>
      {t(`charts.types.${value}`)}
      <div className={styles.chartNavCurrentArrow}>
        <CroplerIcon name="down" />
      </div>
    </div>
  );
}

export default ChartsTypeNavCurrent
